export default "__VITE_ASSET__EH07lyJC__"